<template>
  <div id="berth-form">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center mb-base">
        <div class="flex-grow">
          <div class="insert-data-container">
            <div class="input-area">
              <div class="title-area">
                <span class="title">バース情報</span>
                <div v-if="isViewMode" class="back-button" @click="backToMaster">
                  <feather-icon icon="ChevronLeftIcon" svgClasses="h-5 w-5" />
                  <span>一覧へ戻る</span>
                </div>
              </div>
              <div class="input-group">
                <div class="input-column left-column">
                  <div class="input-row">
                    <div class="string-input">
                      <div class="label">
                        <span class="label">{{inputs.name.label}}</span>
                        <span v-if="!isViewMode" class="validation-label">*</span>
                      </div>
                      <span v-if="isViewMode">{{inputs.name.value}}</span>
                      <vs-input
                        v-else
                        class="name-input"
                        color="#2D9CDB"
                        v-model="inputs.name.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.nameEn.label}}</span>
                      <span v-if="isViewMode">{{inputs.nameEn.value}}</span>
                      <vs-input
                        v-else
                        class="name_en-input"
                        color="#2D9CDB"
                        v-model="inputs.nameEn.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.label.label}}</span>
                      <span v-if="isViewMode">{{inputs.label.value}}</span>
                      <vs-input
                        v-else
                        class="label-input"
                        color="#2D9CDB"
                        v-model="inputs.label.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.code.label}}</span>
                      <span v-if="isViewMode">{{inputs.code.value}}</span>
                      <vs-input
                        v-else
                        class="code-input"
                        color="#2D9CDB"
                        v-model="inputs.code.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.adminCode.label}}</span>
                      <span v-if="isViewMode">{{inputs.adminCode.value}}</span>
                      <vs-input
                        v-else
                        class="code-input"
                        color="#2D9CDB"
                        v-model="inputs.adminCode.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="color-input">
                      <span class="label">{{inputs.color.label}}</span>
                      <editable-color-cell
                        :isEditing="!isViewMode"
                        :color="inputs.color.value"
                        @updateValue="updateColorValue($event)"
                        :colorOptions="colorOptions"
                      >
                      </editable-color-cell>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="select-input">
                      <span class="label">{{inputs.wharf.label}}</span>
                      <span v-if="isViewMode">{{inputs.wharf.value ? inputs.wharf.value.name : ""}}</span>
                      <editable-select-cell
                        v-else
                        :isEditing="!isViewMode"
                        :selectOptions="wharfOptions"
                        @updateValue="updateWharfValue($event)"
                        :value="inputs.wharf.value.id"
                      >
                      </editable-select-cell>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="isViewMode">
                <vs-button color="#2D9CDB" @click="isEditing = true">編集</vs-button>
                <vs-button class="insert-button" color="#BDBDBD" @click="popupActive=true">削除</vs-button>
              </template>
              <template v-else-if="isEditMode">
                <vs-button color="#BDBDBD" @click="cancelEdit">キャンセル</vs-button>
                <vs-button :disabled="!activeInsertButton" class="insert-button" color="#2D9CDB" @click="updateData">保存</vs-button>
              </template>
              <template v-else>
                <vs-button color="#BDBDBD" :to="{name: 'addon-port-master-berth-master'}">キャンセル</vs-button>
                <vs-button :disabled="!activeInsertButton" class="insert-button" color="#2D9CDB" @click="insertData">登録</vs-button>
              </template>
            </div>
          </div>
        </div>
      </div>
      <vs-popup class="basic-master-popup"  title="船舶の削除" :active.sync="popupActive">
        <p>
          「{{inputs.nameEn.value || inputs.name.value}}」を削除してよろしいですか？
        </p>
        <div class="button-area">
          <vs-button class="popup-button" color="#BDBDBD" @click="popupActive = false">キャンセル</vs-button>
          <vs-button class="popup-button" color="#2D9CDB" @click="callDelete">削除</vs-button>
        </div>
      </vs-popup>
      <error-dialog
        ref="errorDialog"
      ></error-dialog>
    </div>
  </div>
</template>

<script>

import ErrorDialog from "../components/ErrorDialog";
import EditableColorCell from "../components/EditableColorCell";
import EditableSelectCell from "../components/EditableSelectCell";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMaster");

export default {
  components: {
    EditableColorCell,
    EditableSelectCell,
    ErrorDialog,
  },
  props: {
    mode: { type: String, required: true }, // "view" or "insert"
    lastSearchCondition: { type: Object }
  },
  data() {
    return {
      isEditing: false,
      wharfOptions: [
      ],
      inputs: {
        name: {
          label: "バース名（和）",
          value: null,
          originalValue: null,
        },
        nameEn: {
          label: "バース名（英）",
          value: null,
          originalValue: null,
        },
        label: {
          label: "略称",
          value: null,
          originalValue: null,
        },
        code: {
          label: "バースコード",
          value: null,
          originalValue: null,
        },
        adminCode: {
          label: "管理コード",
          value: null,
          originalValue: null,
        },
        color: {
          label: "カラーコード",
          value: null,
          originalValue: null,
        },
        wharf: {
          label: "埠頭",
          value: {
            id: null,
            name: null,
          },
          originalValue: {
            id: null,
            name: null,
          },
        },
      },
      version: null,
      inputValues: [],
      popupActive: false,
    }
  },
  async created() {
    this.$vs.loading()
    await this.fetchColors(this.selectedPort.id)
    let res = await this.fetchWharfs(this.selectedPort.id)
    this.wharfOptions = res.wharfs

    if (this.isViewMode) {
      let payload = {
        portId: this.selectedPort.id,
        id: this.$route.params.itemId,
      }
      
      let res = await this.fetchBerthDetail(payload)
      let berth = res.berth
      
      this.inputs.label.value = berth.label
      this.inputs.name.value = berth.name
      this.inputs.nameEn.value = berth.name_en
      this.inputs.code.value = berth.code
      this.inputs.adminCode.value = berth.admin_code
      this.inputs.color.value = berth.color
      this.inputs.wharf.value = berth.wharf ? berth.wharf : { id: null }

      this.version = berth.version

      Object.keys(this.inputs).forEach(key => {
        this.inputs[key].originalValue = this.inputs[key].value
      })
    }
    this.$vs.loading.close()
  },
  computed: {
    ...mapState({
      selectedPort: state => state.selectedPort,
      colorOptions: state => state.colorOptions,
    }),
    isViewMode() {
      return this.mode == "view" && !this.isEditing
    },
    isEditMode() {
      return this.isEditing
    },
    activeInsertButton() {
      let regex = /.+/
      return this.inputs.name.value ? this.inputs.name.value.match(regex) : false
    }
  },
  methods: {
    ...mapActions(["insertBerth", "fetchColors", "fetchBerthDetail", "updateBerth", "deleteBerth", "fetchWharfs"]),
    updateWharfValue(value) {
      this.inputs.wharf.value.id = value
    },
    updateColorValue(value) {
      this.inputs.color.value = value
    },
    cancelEdit() {
      this.isEditing = false
      Object.keys(this.inputs).forEach(key => {
        this.inputs[key].value = this.inputs[key].originalValue
      })
    },
    backToMaster() {
      this.$router.push(
        {
          name: "addon-port-master-berth-master"
        }
      )
    },
    removeTagById(id){
      this.inputs.tags.value = this.inputs.tags.value.filter(option => option.id != id)
    },
    async callDelete() {
      this.popupActive = false
      let payload = {
        portId: this.selectedPort.id,
        id: this.$route.params.itemId,
      }
      try {
        this.$vs.loading()
        await this.deleteBerth(payload)
        this.$vs.loading.close()
        this.$vs.notify({
          title: "データを削除しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
        this.$router.push(
          {
            name: "addon-port-master-berth-master"
          }
        )
      } catch(e) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: "データを削除できませんでした。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        })
      }
    },
    async updateData() {
      let name = this.inputs.name.value
      let name_en = this.inputs.nameEn.value
      let label = this.inputs.label.value
      let code = this.inputs.code.value
      let admin_code = this.inputs.adminCode.value
      let color_id = this.inputs.color.value ? this.inputs.color.value.id : null
      let wharf_id = this.inputs.wharf.value ? this.inputs.wharf.value.id : null

      let payload = {
        portId: this.selectedPort.id,
        id: this.$route.params.itemId,
        body: {
          admin_code: admin_code,
          code: code,
          color_id: color_id,
          label: label,
          name: name,
          name_en: name_en,
          wharf_id: wharf_id,

          version: this.version
        }
      }

      try {
        this.$vs.loading()
        await this.updateBerth(payload)
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
        this.$router.push(
          {
            name: "addon-port-master-berth-master",
            params: { lastSearchCondition: this.lastSearchCondition }
          }
        )
      } catch(error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map(element => {
            let label = this.inputs[element.target].label
            let message = element.message
            return {
              label: label,
              message: message
            }
          })
          this.$refs.errorDialog.open("エラー", null, validationErrors)
        } else {
          this.$refs.errorDialog.open("エラー", error.message, null)
        }
      }
      this.$vs.loading.close()
    },
    async insertData() {
      let name = this.inputs.name.value
      let name_en = this.inputs.nameEn.value
      let label = this.inputs.label.value
      let admin_code = this.inputs.adminCode.value
      let code = this.inputs.code.value
      let color_id = this.inputs.color.value ? this.inputs.color.value.id : null
      let wharf_id = this.inputs.wharf.value ? this.inputs.wharf.value.id : null

      let payload = {
        portId: this.selectedPort.id,
        id: this.$route.params.itemId,
        body: {
          admin_code: admin_code,
          code: code,
          color_id: color_id,
          label: label,
          name: name,
          name_en: name_en,
          wharf_id: wharf_id,

          version: this.version
        }
      }
      try {
        this.$vs.loading()
        await this.insertBerth(payload)
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
        this.$router.push(
          {
            name: "addon-port-master-berth-master"
          }
        )
      } catch(error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map(element => {
            let label = this.inputs[element.target].label
            let message = element.message
            return {
              label: label,
              message: message
            }
          })
          this.$refs.errorDialog.open("エラー", null, validationErrors)
        } else {
          this.$refs.errorDialog.open("エラー", error.message, null)
        }
      }
      this.$vs.loading.close()
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
#berth-form {
  .vs-con-textarea {
    margin: 0px;
  }
  .vx-card {
    min-width: 1100px;
  }
  .insert-data-container {
    display: flex;
    justify-content: space-between;
  }
  .title-area {
    display: flex;
  }
  .title {
    font-size: 18px;
  }
  .title-area {
    display: flex;
  }
  .back-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 30px;
    color: #2D9CDB;
    cursor: pointer;
  }
  .input-area {
    width: 100%;
  }
  .input-group {
    width: 100%;
    display: flex;
  }
  .input-column {
    width: 500px;
  }
  .right-column {
    margin-left: 60px;
  }
  .small-input-row {
    display: flex;
    justify-content: space-between;
  }
  .required-note-input {
    flex-grow: 1;
  }
  .input-row {
    margin: 20px 0px;
  }
  .editable-color {
    width: 300px;
  }
  .string-input, .color-input, .select-input {
    height: 42px;
    display: flex;
    align-items: center;
  }
  .text-are-input {
    display: flex;
  }
  .tag-area {
    line-height: 1;
  }
  .read-only-tag {
    margin-bottom: 0px;
  }
  .multiselect__tag-icon:hover {
    background: #666;
  }
  .label-input, .name-input {
    width: 300px;
  }
  .number-input {
    width: 40px;
  }
  .label {
    width: 110px;
  }
  .validation-label {
    color: red;
    margin-left: 4px;
  }
  .insert-button {
    margin-top: 10px;
    margin-left: 10px;
  }
}
</style>
